export default function () {
  return {
    salesClerks: {},
    loading: false,
  }
}
